import { render, staticRenderFns } from "./Side-Trouble-Basic-Group.vue?vue&type=template&id=6fe24fc6"
import script from "./Side-Trouble-Basic-Group.vue?vue&type=script&lang=js"
export * from "./Side-Trouble-Basic-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports